module.exports = __webpack_public_path__ + "static/img/d2.9d5a4e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/medication/d2.png
// module id = xNwr
// module chunks = 1